import { useRef } from "react"
import { Select as SharedSelect } from "source/shared/components"
import {
  ChurchCenterCustomFieldApiRecordWithRelationships,
  UpdateCustomFieldAttributes,
} from "source/myChurchCenter/Profile/types"
import { Icon } from "source/shared/components"

export function Select({
  customField,
  updateAttributes,
}: {
  customField: ChurchCenterCustomFieldApiRecordWithRelationships
  updateAttributes: UpdateCustomFieldAttributes
}) {
  const fieldName =
    customField.relationships.field_definition.data.attributes.name
  const options = customField.relationships.field_options?.data
  const fieldValue =
    customField.relationships.field_data?.data[0]?.attributes?.value

  const {
    attributes: { editing_rules: editingRules },
  } = customField

  const valueRef = useRef(fieldValue)

  const disabled =
    editingRules === "view" ||
    !!(editingRules === "add_if_blank" && valueRef.current)

  return (
    <div key={customField.id}>
      <div className="d-f">
        <label htmlFor={fieldName}>{fieldName}</label>
        {disabled && <Icon symbol="general#lock" className="fs-2 pl-1 pt-1" />}
      </div>
      <SharedSelect
        disabled={disabled}
        name={fieldName}
        onChange={(e) => {
          updateAttributes({
            customField,
            record: customField.relationships.field_data?.data[0] || null,
            attributes: {
              value: e.target.value,
              field_option_id:
                options?.find(
                  (option) => option.attributes.label === e.target.value,
                )?.id || "",
            },
          })
        }}
        value={fieldValue || ""}
        options={[
          {
            key: `${customField.id}-select-option-0`,
            label: "Select...",
            value: "",
          },
          ...(options?.map((option) => ({
            key: `${customField.id}-select-option-${option.id}`,
            label: option.attributes.label,
            value: option.attributes.label,
          })) || []),
        ]}
      />
    </div>
  )
}
